import React from "react";
import "./BottomTabs.css";
import { useNavigate } from "react-router-dom";
import { FaHome, FaGamepad, FaDownload, FaHeart } from "react-icons/fa";
import IconsBot from "./Icon.png";

//
const BottomTabs = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="bottom-tabs">
        <div className="tab" onClick={() => navigate("/home")}>
          <FaHome className="tab-icon" />
          <span className="tab-label">Home</span>
        </div>
        <div className="tab" onClick={() => navigate("/games-all")}>
          <FaGamepad className="tab-icon" />
          <span className="tab-label">All Games</span>
        </div>
        <div className="tab" onClick={() => navigate("/downloadnow")}>
          <FaDownload className="tab-icon" />
          <span className="tab-label">Download</span>
        </div>
        <div className="tab" onClick={() => navigate("/favorites")}>
          <FaHeart className="tab-icon" />
          <span className="tab-label">Favorite</span>
        </div>
      </div>
      <button
        className="chat-ai-btn"
        onClick={() => navigate("/chat-ai")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") navigate("/chat-ai");
        }}
      >
        <span className="chat-ai-icon">
          <img
            src="https://cdn-icons-png.flaticon.com/128/16806/16806607.png"
            alt=""
            width={100}
            height={50}
            style={{ marginBottom: "5px" }}
            className="aiIcon"
          />
        </span>
        <span className="ai-label"></span>
      </button>
    </>
  );
};

export default BottomTabs;
